import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  INCOMPLETE_ORDERS_FAILURE,
  ORDER_WITH_SHIPMENTS_REQUESTED,
  ORDER_WITH_SHIPMENTS_SUCCESS,
} from '../types';

export const incompleteOrdersRequested = () => {
  return {
    type: INCOMPLETE_ORDERS_REQUESTED
  }
};

export const incompleteOrdersSuccess = (orders) => {
  return {
    type: INCOMPLETE_ORDERS_SUCCESS,
    payload: orders
  }
};

export const incompleteOrdersFailure = () => {
  return {
    type: INCOMPLETE_ORDERS_FAILURE
  }
};

export const orderWithShipmentsRequested = () => {
  return {
    type: ORDER_WITH_SHIPMENTS_REQUESTED
  }
}

export const orderWithShipmentsSuccess = (order) => {
  return {
    type: ORDER_WITH_SHIPMENTS_SUCCESS,
    payload: order
  }
}

export const getIncompleteOrders = (ecwidPayload, orderPage, selectedSearchStatus) => {
  return (dispatch) => {
    dispatch(incompleteOrdersRequested());

    let endPoint = Config.baseUrl + Config.orders + Config.incomplete + `?page=${orderPage}&status=${selectedSearchStatus}`;
    let headers = Object.assign(Config.headers);
    headers.payload = ecwidPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(incompleteOrdersSuccess(response.data));
      })
  }
}

export const orderWithShipments = (ecwidPayload, orderId) => {
  return (dispatch) => {
    dispatch(orderWithShipmentsRequested());

    let endPoint = Config.baseUrl + Config.order + `/${orderId}`;
    let headers = Object.assign(Config.headers);
    headers.payload = ecwidPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(orderWithShipmentsSuccess(response.data));
      })
  }
}
